import {kThemesTexts} from "../../../constants/texts";

export default function ThemesIntroText() {
    // Used in ThemesScreen to display intro text
    // about program

    // BUILD
    return (
        <div>
            <span className={"text-[16px] text-greyLight11 font-medium"}>
                {kThemesTexts.introText}
            </span>
        </div>
    );
}